// extracted by mini-css-extract-plugin
export default {"step":"Step_step__XtLAv","num__container":"Step_num__container__hXHj2","num":"Step_num__gawXy","value":"Step_value__PrCDj"};